import Box from '@mui/material/Box';

import useStyles from './KeyValue.styles';
import type { KeyValueProps } from './KeyValue.types';

const KeyValue = (props: KeyValueProps) => {
  const { classes } = useStyles();
  const { items } = props;
  return (
    <>
      {items.map((row) => {
        return (
          <Box key={row.label} className={classes.KVFlex}>
            <Box className={classes.flexLeftCol}>{row.label}</Box>
            <Box className={classes.flexRightCol}>{row.value}</Box>
          </Box>
        );
      })}
    </>
  );
};
export default KeyValue;
